import React from "react";
import Box from "@mui/material/Box";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import axios from "axios";
import SweetAlert from "react-bootstrap-sweetalert";
import Pagination from "../../Pagination/Pagination";
import { useAppContext } from "../../Lib/ContextLib";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import Loader from "../Loader/Loader";
import EmptyState from "../../Components/EmptyState";
import CloseIcon from "@mui/icons-material/Close";
import ClearIcon from "@mui/icons-material/Clear";
import FileUpload from "react-drag-n-drop-image";
import { API_URL } from "../../config";
import moment from "moment";
import Select from "react-select";

function CustomBody() {
  return (
    <div
      className="drag-file-area mt-0"
      style={{
        border: "0px",
        borderRadius: "0px",
        width: "100%",
        position: "relative",
      }}
    >
      <div>
        <CloudDownloadIcon style={{ fontSize: "50px" }} />
      </div>
      <h3 className="dynamic-message" style={{ fontFamily: "Montserrat" }}>
        Drag &amp; drop any file here
      </h3>
      <label className="">
        <span className="">
          <span
            className="browse-files-text"
            style={{
              fontFamily: "Montserrat",
              color: "#539ffe",
            }}
          >
            browse file
          </span>
          <span style={{ fontFamily: "Montserrat" }}>from device</span>
        </span>
      </label>
    </div>
  );
}

function ShowData({ files, onRemoveImage }) {
  return (
    <div className="">
      {files.map((item) => {
        return (
          <>
            <div
              className="drag-file-area mt-0"
              style={{
                border: "0px",
                borderRadius: "0px",
                position: "relative",
              }}
            >
              <div className="d-flex" style={{ justifyContent: "center" }}>
                <div style={{ height: "200px", width: "200px" }} className="">
                  <img
                    src={item.preview}
                    alt="Image preview..."
                    height="100%"
                    width="100%"
                    style={{ objectFit: "contain" }}
                  />
                </div>
                <CloseIcon
                  style={{
                    cursor: "pointer",
                    color: "red",
                    position: "absolute",
                    right: 10,
                    top: 10,
                  }}
                  onClick={() => onRemoveImage(item.id)}
                />
              </div>
            </div>
          </>
        );
      })}
    </div>
  );
}

const selectStyles = {
  control: (provided, state) => ({
    ...provided,
    borderRadius: "8px",
    border: state.isFocused ? "1.5px solid #539ffe" : "1.5px solid #e2e8f0",
    boxShadow: state.isFocused ? "0 0 0 4px rgba(83, 159, 254, 0.15)" : "0 1px 2px rgba(0, 0, 0, 0.03)",
    padding: "2px 8px",
    fontSize: "0.95rem",
    backgroundColor: "#ffffff",
    transition: "all 0.2s ease",
    "&:hover": {
      borderColor: state.isFocused ? "#539ffe" : "#cbd5e1",
    },
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "#539ffe"
      : state.isFocused
        ? "rgba(83, 159, 254, 0.1)"
        : "#fff",
    color: state.isSelected ? "#fff" : "#1e293b",
    padding: "10px 15px",
    cursor: "pointer",
    "&:active": {
      backgroundColor: "#539ffe",
    },
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: "12px",
    boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
    overflow: "hidden",
    border: "1px solid #e2e8f0",
    zIndex: 9999,
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: "rgba(83, 159, 254, 0.15)",
    borderRadius: "6px",
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: "#0b4b9b",
    fontWeight: "500",
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: "#539ffe",
    "&:hover": {
      backgroundColor: "#539ffe",
      color: "#fff",
      borderRadius: "0 6px 6px 0",
    },
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
};

export default function SendNotification() {
  const { showPage, setShowPage, accessObject, socket } = useAppContext();
  const [progressData, setProgressData] = React.useState(null);

  React.useEffect(() => {
    return () => {
      if (socket) {
        socket.off("notification-progress");
      }
    };
  }, [socket]);

  const [alert, setAlert] = React.useState(null);
  const [tableData, setTableData] = React.useState([]);
  const [rowValue, setRowValue] = React.useState();
  const [openValue, setOpenValue] = React.useState(0);
  const [loader, setLoader] = React.useState(false);
  const [showPrePage, setShowPrePage] = React.useState(10);
  const [imageFile, setImageFile] = React.useState();
  const [iconFile, setIconFile] = React.useState();
  const [buttonLoader, setbuttonLoader] = React.useState(false);
  const [files, setFiles] = React.useState([]);
  const [iconFiles, setIconFiles] = React.useState([]);
  const [showImages, setShowData] = React.useState(false);
  const [showIcons, setShowIcons] = React.useState(false);
  const [isEditDataImage1, setIsEditDataImage1] = React.useState(false);
  const [pagination, setPagination] = React.useState({
    start: 0,
    end: showPrePage,
  });
  const [searchTerm, setSearchTerm] = React.useState("");
  const [filteredData, setFilteredData] = React.useState([]);
  const [totalData, setTotalData] = React.useState(0);
  const [debouncedSearch, setDebouncedSearch] = React.useState("");

  // States for player selection dropdown
  const [playerOptions, setPlayerOptions] = React.useState([]);
  const [selectLoading, setSelectLoading] = React.useState(false);
  const [inputValue, setInputValue] = React.useState("");

  const fetchPlayers = (searchQuery = "") => {
    setSelectLoading(true);
    axios
      .get(`${API_URL}/api/admin/notification/get-notification-user-info`, {
        params: {
          page: 1,
          limit: 10,
          search: searchQuery || ""
        }
      })
      .then((response) => {
        setSelectLoading(false);
        if (response.data.status) {
          const players = response.data.data?.data || [];
          const formatted = players.map((p) => {
            const displayName = p.name || p.userName || p.email || "";
            return {
              value: p.playerId,
              label: displayName ? `${displayName} (${p.playerId})` : p.playerId,
            };
          });

          setPlayerOptions((prevOptions) => {
            const existingMap = new Map(prevOptions.map(o => [o.value, o]));
            formatted.forEach(o => existingMap.set(o.value, o));
            return Array.from(existingMap.values());
          });
        }
      })
      .catch((error) => {
        setSelectLoading(false);
        console.error("fetchPlayers error:", error);
      });
  };

  const fetchSelectedPlayerDetails = async (userIds) => {
    if (!userIds || userIds.length === 0) return;
    try {
      const promises = userIds.map(id =>
        axios.get(`${API_URL}/api/admin/notification/get-notification-user-info`, {
          params: {
            page: 1,
            limit: 1,
            search: id
          }
        })
      );

      const results = await Promise.all(promises);
      const newOptions = [];

      results.forEach((response, idx) => {
        if (response.data.status && response.data.data?.data?.length > 0) {
          const p = response.data.data.data[0];
          if (p.playerId === userIds[idx]) {
            const displayName = p.name || p.userName || p.email || "";
            newOptions.push({
              value: p.playerId,
              label: displayName ? `${displayName} (${p.playerId})` : p.playerId
            });
          } else {
            newOptions.push({
              value: userIds[idx],
              label: userIds[idx]
            });
          }
        } else {
          newOptions.push({
            value: userIds[idx],
            label: userIds[idx]
          });
        }
      });

      setPlayerOptions((prevOptions) => {
        const existingMap = new Map(prevOptions.map(o => [o.value, o]));
        newOptions.forEach(o => existingMap.set(o.value, o));
        return Array.from(existingMap.values());
      });
    } catch (error) {
      console.error("Error fetching selected player details:", error);
      const fallbackOptions = userIds.map(id => ({ value: id, label: id }));
      setPlayerOptions((prevOptions) => {
        const existingMap = new Map(prevOptions.map(o => [o.value, o]));
        fallbackOptions.forEach(o => existingMap.set(o.value, o));
        return Array.from(existingMap.values());
      });
    }
  };

  // Debounce search
  React.useEffect(() => {
    if (showPage) {
      const delayDebounceFn = setTimeout(() => {
        fetchPlayers(inputValue);
      }, 300);

      return () => clearTimeout(delayDebounceFn);
    } else {
      setInputValue("");
      setPlayerOptions([]);
    }
  }, [inputValue, showPage]);

  const getSelectedOptions = (sendUsersValue) => {
    if (!sendUsersValue) return [];
    const ids = sendUsersValue.split(",").map(id => id.trim()).filter(Boolean);
    return ids.map(id => {
      const found = playerOptions.find(opt => opt.value === id);
      return found || { value: id, label: id };
    });
  };

  const handleInputChange = (newValue) => {
    setInputValue(newValue);
  };

  // Debounce search input and handle resetting pagination
  React.useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch((debouncedSearchVal) => {
        if (debouncedSearchVal !== searchTerm) {
          setPagination({ start: 0, end: showPrePage });
          return searchTerm;
        }
        return debouncedSearchVal;
      });
    }, 400);

    return () => clearTimeout(handler);
  }, [searchTerm, showPrePage]);

  // Fetch data whenever debounced search or pagination changes
  React.useEffect(() => {
    getNotificationList();
  }, [debouncedSearch, pagination.start, showPrePage]);

  const onPaginationChange = (start, end) => {
    setPagination({ start: start, end: end });
  };

  const updateShowPerpagevalue = (value) => {
    setShowPrePage(value);
    setPagination({ start: 0, end: value });
  };

  const LoginSchema = Yup.object().shape({
    title: Yup.string().required("required"),
    message: Yup.string().required("required"),
    type: Yup.string().required("required"),
    sendUsers: Yup.string().when("isSendAll", {
      is: false,
      then: Yup.string().required("At least one user ID is required"),
    }),
  });

  const getNotificationList = () => {
    setLoader(true);
    const page = Math.floor(pagination.start / showPrePage) + 1;
    const limit = showPrePage;
    axios(
      `${API_URL}/api/admin/notification/get-notification?page=${page}&limit=${limit}&search=${debouncedSearch || ""}`,
      {
        method: "GET",
        credentials: "include",
      }
    )
      .then((response) => {
        setLoader(false);

        if (response.data.status) {
          const fetchedData = response.data.data?.data || [];
          setTableData(fetchedData);
          setFilteredData(fetchedData);
          setTotalData(response.data.data?.totalLength || 0);
        }
      })
      .catch((error) => {
        setLoader(false);
        console.log("getNotificationList error :::", error);
      });
  };


  const onRemoveImage = (id) => {
    setShowData(false);
    setFiles((prev) => prev.filter((i) => i.id !== id));
    setImageFile(null);
  };

  const onRemoveIcon = (id) => {
    setShowIcons(false);
    setIconFiles((prev) => prev.filter((i) => i.id !== id));
    setIconFile(null);
  };

  const onError = (error) => {
    console.error(error);
  };

  const onChangeImage = (e) => {
    if (files.length === 0) {
      setShowData(true);
      setImageFile(e[0].file);
      setFiles(e);
    }
  };

  const onChangeIcon = (e) => {
    if (iconFiles.length === 0) {
      setShowIcons(true);
      setIconFile(e[0].file);
      setIconFiles(e);
    }
  };

  const openAddTournament = (value) => {
    setImageFile(null);
    setIconFile(null);
    setFiles([]);
    setIconFiles([]);
    setShowData(false);
    setShowIcons(false);
    setIsEditDataImage1(false);
    setRowValue();
    setShowPage(true);
    setOpenValue(value);
  };

  const editNotification = (notification) => {
    setRowValue(notification);
    setOpenValue(2); // 1 for add, 2 for edit
    setShowPage(true);

    // Parse and fetch selected user details
    const existingUsers = notification.sendUsers
      ? (Array.isArray(notification.sendUsers)
        ? notification.sendUsers
        : notification.sendUsers.split(",").map(id => id.trim()).filter(Boolean))
      : [];

    if (existingUsers.length > 0) {
      fetchSelectedPlayerDetails(existingUsers);
    }

    // Set image and icon previews if they exist
    if (notification.imageUrl) {
      setFiles([
        {
          id: "1",
          preview: notification.imageUrl,
          file: null,
        },
      ]);
      setShowData(true);
    }

    if (notification.iconUrl) {
      setIconFiles([
        {
          id: "1",
          preview: notification.iconUrl,
          file: null,
        },
      ]);
      setShowIcons(true);
    }
  };

  const addNewNotificcation = (value) => {
    const formData = new FormData();

    if (imageFile) {
      formData.append("image", imageFile);
    }
    if (iconFile) {
      formData.append("icon", iconFile);
    }

    formData.append("title", value?.title);
    formData.append("message", value?.message);
    formData.append("type", value?.type);
    formData.append("buttonName", value?.buttonName || "");
    formData.append("buttonURL", value?.buttonURL || "");

    if (value.isSendAll) {
      formData.append("isSendAll", "true");
    } else {
      formData.append(
        "sendUsers",
        JSON.stringify(value.sendUsers.split(",").map((id) => id.trim()))
      );
      formData.append("isSendAll", "false");
    }

    if (socket && socket.id) {
      formData.append("adminSocketId", socket.id);
    }

    setbuttonLoader(true);

    axios(`${API_URL}/api/admin/notification/add-notification`, {
      method: "POST",
      credentials: "include",
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then((result) => {
        if (result.data.status) {
          setbuttonLoader(false);
          const notificationId = result.data.data?._id;

          setProgressData({
            sentCount: 0,
            totalCount: 0,
            successCount: 0,
            failureCount: 0,
            percentage: 0,
            status: "processing"
          });

          if (socket) {
            const handleProgress = (progress) => {
              console.log("notification-progress update:", progress);
              if (!notificationId || progress.notificationId === notificationId) {
                setProgressData({
                  sentCount: progress.sentCount,
                  totalCount: progress.totalCount,
                  successCount: progress.successCount || 0,
                  failureCount: progress.failureCount || 0,
                  percentage: progress.percentage,
                  status: progress.status
                });

                if (progress.status === "completed") {
                  socket.off("notification-progress", handleProgress);
                  setProgressData(null);
                  const successMsg = `Dispatched successfully! Sent: ${progress.successCount || 0}, Failed: ${progress.failureCount || 0}`;
                  successAdd(successMsg);
                } else if (progress.status === "failed") {
                  socket.off("notification-progress", handleProgress);
                  setProgressData(null);
                  warningAlert(progress.error || "Notification dispatch failed.");
                }
              }
            };
            socket.on("notification-progress", handleProgress);
          } else {
            successAdd(result.data.message);
          }
        } else {
          warningAlert();
          setbuttonLoader(false);
        }
      })
      .catch((err) => {
        console.log("handleSubmit err :::", err);
        warningAlert();
        setbuttonLoader(false);
      });
  };

  const updateNotification = (value) => {
    const formData = new FormData();

    if (imageFile) {
      formData.append("image", imageFile);
    }
    if (iconFile) {
      formData.append("icon", iconFile);
    }

    formData.append("title", value?.title);
    formData.append("message", value?.message);
    formData.append("type", value?.type);
    formData.append("buttonName", value?.buttonName || "");
    formData.append("buttonURL", value?.buttonURL || "");

    if (value.isSendAll) {
      formData.append("isSendAll", "true");
    } else {
      formData.append(
        "sendUsers",
        JSON.stringify(value.sendUsers.split(",").map((id) => id.trim()))
      );
      formData.append("isSendAll", "false");
    }

    setbuttonLoader(true);

    axios(
      `${API_URL}/api/admin/notification/update-notification/${rowValue._id}`,
      {
        method: "PATCH",
        credentials: "include",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    )
      .then((result) => {
        if (result.data.status) {
          setbuttonLoader(false);
          successAdd(result.data.message);
        } else {
          warningAlert();
          setbuttonLoader(false);
        }
      })
      .catch((err) => {
        console.log("update err :::", err);
        warningAlert();
        setbuttonLoader(false);
      });
  };

  const deleteNotification = (id) => {
    setAlert(
      <SweetAlert
        custom
        showCancel
        confirmBtnText="Yes, Delete"
        cancelBtnText="Cancel"
        confirmBtnBsStyle="danger"
        cancelBtnBsStyle="default"
        onConfirm={() => {
          setLoader(true);
          axios(`${API_URL}/api/admin/notification/delete-notification/${id}`, {
            method: "DELETE",
            credentials: "include",
          })
            .then((response) => {
              setLoader(false);
              if (response.data.status) {
                successAdd(response.data.message);
              } else {
                warningAlert();
              }
            })
            .catch((error) => {
              console.log("delete error :::", error);
              warningAlert();
              setLoader(false);
            });
        }}
        onCancel={() => setAlert(null)}
        customClass="premium-alert"
        confirmBtnClass="premium-alert-confirm bg-danger shadow-danger"
        cancelBtnClass="premium-alert-cancel"
        customIcon={<div className="mb-4" style={{ fontSize: '50px', color: '#dc3545' }}><i className="fas fa-trash-alt"></i></div>}
      >
        <div className="premium-alert-title">Are you sure?</div>
        <p className="premium-alert-text">You are about to delete this notification record. This action cannot be undone.</p>
      </SweetAlert>
    );
  };

  const handleSubmit = (values) => {
    setbuttonLoader(true);
    if (openValue === 1) {
      addNewNotificcation(values);
    } else if (openValue === 2) {
      updateNotification(values);
    }
  };

  const renderSentTo = (item) => {
    if (item.isSendAll === true || item.isSendAll === "true" || !item.sendUsers) {
      return { text: "All Users", moreCount: 0, fullList: "All Users" };
    }

    let users = [];
    if (Array.isArray(item.sendUsers)) {
      users = item.sendUsers;
    } else if (typeof item.sendUsers === "string") {
      try {
        const parsed = JSON.parse(item.sendUsers);
        users = Array.isArray(parsed) ? parsed : [item.sendUsers];
      } catch (e) {
        users = item.sendUsers.split(",").map(u => u.trim());
      }
    }

    if (users.length === 0) {
      return { text: "All Users", moreCount: 0, fullList: "All Users" };
    }

    const fullList = users.join(", ");
    if (users.length <= 2) {
      return { text: fullList, moreCount: 0, fullList };
    }
    return {
      text: users.slice(0, 2).join(", "),
      moreCount: users.length - 2,
      fullList
    };
  };

  const successAdd = (msg) => {
    setAlert(
      <SweetAlert
        success
        onConfirm={() => {
          getNotificationList();
          setAlert(null);
          setShowPage(false);
        }}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm"
      >
        <div className="premium-alert-title">Success!</div>
        <p className="premium-alert-text">{msg || "The notification record has been saved successfully."}</p>
      </SweetAlert>
    );
  };

  const warningAlert = (msg) => {
    setAlert(
      <SweetAlert
        warning
        onConfirm={() => setAlert(null)}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm"
      >
        <div className="premium-alert-title">Wait!</div>
        <p className="premium-alert-text">{msg || "Something went wrong. Please try again later."}</p>
      </SweetAlert>
    );
  };

  return (
    <div>
      {alert}
      {progressData && (
        <SweetAlert
          custom
          showConfirm={false}
          title=""
          customClass="premium-alert"
        >
          <div className="premium-alert-title mb-4">Sending Notifications</div>
          <div className="d-flex flex-column align-items-center justify-content-center px-3">
            <div className="progress w-100 mb-3" style={{ position: "relative", height: "24px", borderRadius: "12px", overflow: "hidden", backgroundColor: "#f1f5f9", border: "1px solid #e2e8f0" }}>
              <div
                className="progress-bar progress-bar-striped progress-bar-animated"
                role="progressbar"
                style={{
                  position: "relative",
                  left: "0",
                  bottom: "auto",
                  height: "100%",
                  width: `${progressData.percentage}%`,
                  backgroundImage: "linear-gradient(45deg, #539ffe 25%, #3b82f6 50%, #539ffe 75%)",
                  borderRadius: "12px",
                  transition: "width 0.4s ease",
                  fontSize: "0.85rem",
                  fontWeight: "bold",
                  lineHeight: "22px",
                  color: "#ffffff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}
                aria-valuenow={progressData.percentage}
                aria-valuemin="0"
                aria-valuemax="100"
              >
                {progressData.percentage}%
              </div>
            </div>
            <div className="premium-alert-text" style={{ fontSize: "1.1rem", fontWeight: "600", color: "#1e293b" }}>
              Sent {progressData.sentCount} of {progressData.totalCount} users
            </div>
            {(progressData.successCount > 0 || progressData.failureCount > 0) && (
              <div className="d-flex justify-content-around w-100 mt-2 mb-1" style={{ fontSize: "0.95rem", fontWeight: "600" }}>
                <span className="text-success">
                  <i className="fas fa-check-circle mr-1"></i> Success: {progressData.successCount}
                </span>
                <span className="text-danger">
                  <i className="fas fa-times-circle mr-1"></i> Failed: {progressData.failureCount}
                </span>
              </div>
            )}
            <p className="text-muted small mt-2">Please keep this window open while the dispatch is in progress.</p>
          </div>
        </SweetAlert>
      )}
      {showPage ? (
        <div className="content p-3 ">
          <div className="card p-3">
            <Box sx={{ width: "100%" }}>
              <Formik
                initialValues={{
                  type: rowValue ? rowValue?.type : "0",
                  title: rowValue ? rowValue?.title : "",
                  message: rowValue ? rowValue?.message : "",
                  buttonName: rowValue ? rowValue?.buttonName : "",
                  buttonURL: rowValue ? rowValue?.buttonURL : "",
                  sendUsers: rowValue
                    ? Array.isArray(rowValue?.sendUsers)
                      ? rowValue?.sendUsers?.join(", ")
                      : rowValue?.sendUsers || ""
                    : "",
                  isSendAll: rowValue ? rowValue?.isSendAll : false,
                }}
                validationSchema={LoginSchema}
                onSubmit={handleSubmit}
              >
                {({ touched, errors, values, setFieldValue }) => (
                  <Form>
                    <div className="row">
                      {/* Notification Type & Title */}
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Notification Type <span className="text-danger">*</span></label>
                          <Field
                            as="select"
                            name="type"
                            className={`mt-1 form-control ${touched.type && errors.type ? "is-invalid" : ""}`}
                          >
                            <option value="0">Transactional</option>
                            <option value="1">Promotional</option>
                          </Field>
                          <ErrorMessage component="div" name="type" className="invalid-feedback" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Title <span className="text-danger">*</span></label>
                          <Field
                            type="text"
                            name="title"
                            placeholder="Enter notification title"
                            className={`mt-1 form-control ${touched.title && errors.title ? "is-invalid" : ""}`}
                          />
                          <ErrorMessage component="div" name="title" className="invalid-feedback" />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      {/* Message */}
                      <div className="col-md-12">
                        <div className="form-group">
                          <label>Message <span className="text-danger">*</span></label>
                          <Field
                            as="textarea"
                            name="message"
                            placeholder="Enter notification message"
                            rows={3}
                            className={`mt-1 form-control ${touched.message && errors.message ? "is-invalid" : ""}`}
                          />
                          <ErrorMessage component="div" name="message" className="invalid-feedback" />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      {/* Button Details */}
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Action Button Label</label>
                          <Field
                            type="text"
                            name="buttonName"
                            placeholder="e.g. Play Now"
                            className="mt-1 form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Action Button URL</label>
                          <Field
                            type="text"
                            name="buttonURL"
                            placeholder="https://example.com"
                            className="mt-1 form-control"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group custom-control custom-switch mt-3 mb-3 ml-1">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="isSendAll"
                            checked={values.isSendAll}
                            onChange={(e) => setFieldValue("isSendAll", e.target.checked)}
                          />
                          <label className="custom-control-label" htmlFor="isSendAll">
                            Send to all users
                          </label>
                        </div>
                      </div>
                    </div>

                    {!values.isSendAll && (
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form-group">
                            <label>Specific User IDs <span className="text-danger">*</span></label>
                            <Select
                              isMulti
                              name="sendUsers"
                              options={playerOptions}
                              isLoading={selectLoading}
                              onInputChange={handleInputChange}
                              value={getSelectedOptions(values.sendUsers)}
                              onChange={(selectedOptions) => {
                                const valueString = selectedOptions
                                  ? selectedOptions.map(opt => opt.value).join(", ")
                                  : "";
                                setFieldValue("sendUsers", valueString);
                              }}
                              placeholder="Search and select user IDs..."
                              className={`mt-1 basic-multi-select ${touched.sendUsers && errors.sendUsers ? "is-invalid" : ""}`}
                              classNamePrefix="select"
                              styles={selectStyles}
                              noOptionsMessage={() => (selectLoading ? "Loading players..." : "No players found")}
                            />
                            <small className="text-muted">Search by player name, email, or user ID. You can select multiple players.</small>
                            {touched.sendUsers && errors.sendUsers && (
                              <div className="text-danger small mt-1">{errors.sendUsers}</div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="row mt-3">
                      {/* Image Upload */}
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="mb-2">Notification Banner</label>
                          <div className="file-upload-box">
                            {showImages ? (
                              <ShowData files={files} onRemoveImage={onRemoveImage} />
                            ) : (
                              <FileUpload
                                onError={onError}
                                body={<CustomBody />}
                                overlap={false}
                                fileValue={files}
                                onChange={(e) => onChangeImage(e)}
                              />
                            )}
                          </div>
                        </div>
                      </div>

                      {/* Icon Upload */}
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="mb-2">Notification Icon</label>
                          <div className="file-upload-box">
                            {showIcons ? (
                              <ShowData files={iconFiles} onRemoveImage={onRemoveIcon} />
                            ) : (
                              <FileUpload
                                onError={onError}
                                body={<CustomBody />}
                                overlap={false}
                                fileValue={iconFiles}
                                onChange={(e) => onChangeIcon(e)}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="d-flex mt-4 pt-4 border-top">
                      <button
                        style={{ width: "110px" }}
                        type="submit"
                        className="btn btn-primary mr-2"
                        disabled={buttonLoader}
                      >
                        <div className="d-flex align-items-center justify-content-center">
                          <b>{openValue === 1 ? "Submit" : "Update"}</b>
                          {buttonLoader && (
                            <div className="spinner-border ml-2" role="status" style={{ height: "16px", width: "16px" }} />
                          )}
                        </div>
                      </button>
                      <button
                        style={{ width: "110px" }}
                        onClick={() => setShowPage(false)}
                        type="button"
                        className="btn btn-secondary ms-2"
                      >
                        Cancel
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </Box>
          </div>
        </div>
      ) : (
        <div className="content p-3">
          <div className="card ">
            <div className="card-header bg-white border-bottom-0 pb-0 pt-4 px-4">
              <div className="row align-items-center">
                <div className="col-md-6 mb-3 mb-md-0">
                  <div className="position-relative">
                    <i className="fas fa-search text-muted position-absolute" style={{ left: '16px', top: '50%', transform: 'translateY(-50%)', zIndex: 10, fontSize: '0.9rem' }}></i>
                    <input
                      className="premium-search-input"
                      type="text"
                      placeholder="Search Notification..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-md-6 text-right">
                  {accessObject?.bannerAdd === true && (
                    <button
                      onClick={() => {
                        openAddTournament(1);
                      }}
                      type="button"
                      className="btn btn-primary"
                    >
                      <AddIcon /> Add New
                    </button>
                  )}
                </div>
              </div>
            </div>

            <div className="card-body" style={{ overflow: "scroll" }}>
              <table id="" className="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>SrNo</th>
                    <th>Date</th>
                    <th>Sent To</th>
                    <th>Type</th>
                    <th>Title</th>
                    <th>Message</th>
                    <th>Button</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                {accessObject?.getNotificationList === true ? (
                  <tbody>
                    {!loader ? (
                      filteredData.length > 0 ? (
                        filteredData.map((item, index) => (
                          <tr key={index}>
                            <td>{index + 1 + pagination.start}</td>
                            <td>
                              {moment(item.createdAt).format(
                                "DD/MM/YYYY"
                              )}
                            </td>
                            <td
                              style={{
                                maxWidth: "250px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap"
                              }}
                              title={renderSentTo(item).fullList}
                            >
                              {renderSentTo(item).text}
                              {renderSentTo(item).moreCount > 0 && (
                                <span
                                  className="ml-1"
                                  style={{
                                    fontWeight: "bold",
                                    color: "#d97706",
                                    backgroundColor: "rgba(249, 193, 48, 0.15)",
                                    padding: "2px 6px",
                                    borderRadius: "4px",
                                    fontSize: "0.8rem",
                                    display: "inline-block"
                                  }}
                                >
                                  +{renderSentTo(item).moreCount} more
                                </span>
                              )}
                            </td>
                            <td>
                              {item.type === "0"
                                ? "Transactional"
                                : "Promotional"}
                            </td>
                            <td
                              style={{
                                maxWidth: "150px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap"
                              }}
                              title={item.title}
                            >
                              {item.title}
                            </td>
                            <td
                              style={{
                                maxWidth: "300px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap"
                              }}
                              title={item.message}
                            >
                              {item.message}
                            </td>
                            <td
                              style={{
                                maxWidth: "200px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap"
                              }}
                              title={item.buttonName ? `${item.buttonName} (${item.buttonURL})` : ""}
                            >
                              {item.buttonName
                                ? `${item.buttonName} (${item.buttonURL})`
                                : "-"}
                            </td>
                            <td>
                              <div className="d-flex">
                                <ClearIcon
                                  className="courser text-danger"
                                  onClick={() => deleteNotification(item._id)}
                                />
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <EmptyState colSpan={8} />
                      )
                    ) : null}
                  </tbody>
                ) : (
                  <tbody>
                    <tr
                      style={{ backgroundColor: "rgba(0,0,0,.05)" }}
                      className="text-center"
                    >
                      <td colSpan={8}>
                        <h5>Access Denied</h5>
                      </td>
                    </tr>
                  </tbody>
                )}
              </table>
              {accessObject?.getNotificationList === true && (
                <div className="mt-4">
                  {loader && <Loader />}
                </div>
              )}
            </div>
            {accessObject?.getNotificationList === true &&
              totalData !== 0 && (
                <Pagination
                  updateShowPerpagevalue={updateShowPerpagevalue}
                  showPrePage={showPrePage}
                  onPaginationChange={onPaginationChange}
                  total={totalData}
                />
              )}
          </div>
        </div>
      )}
    </div>
  );
}
